import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'react-toastify';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      toast.success(response.data.message);
      setResetToken(response.data.resetToken); // For demo purposes
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Cixio</h1>
          <p>Financial & Logistics OS for Indian SME</p>
        </div>

        <h2>Forgot Password</h2>
        <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '24px' }}>
          Enter your email address and we'll send you a link to reset your password
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {resetToken && (
          <div style={{ 
            marginTop: '20px', 
            padding: '12px', 
            background: '#f3f4f6', 
            borderRadius: '8px',
            fontSize: '14px'
          }}>
            <p style={{ margin: 0, color: '#059669', fontWeight: 600 }}>✓ Reset link sent!</p>
            <p style={{ margin: '8px 0 0 0', color: '#6b7280' }}>
              Reset Token (for demo): <code>{resetToken}</code>
            </p>
            <Link to={`/reset-password/${resetToken}`} style={{ color: '#6366f1', textDecoration: 'underline' }}>
              Click here to reset password
            </Link>
          </div>
        )}

        <div className="auth-footer">
          <p>Remember your password? <Link to="/login">Login here</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
